import { Injectable } from '@angular/core';
import { RestService } from '../../core/core/rest.service';
import { StructureUserRole, StructureUser } from './structure-users.model';



@Injectable()
export class UsersRest{
    constructor(
        private http: RestService
    ){}

    public addUser(user: StructureUser){
        return this.http.post('api/user/add', user);
    }

    public editUser(user: StructureUser){
        return this.http.post('api/user/edit', user);
    }

    public deleteUser(id: any){
        return this.http.post('api/user/deactivate', id);
    }

    public activateUser(id: any){
        return this.http.post('api/user/activate', id);
    }
    
    public getUserRoles() {
        return this.http.get<StructureUserRole[]>('api/user/roles/all');
    }

    public getAllUsers() {
        return this.http.get<StructureUser[]>('api/users/all');
    }

    public markPasswordChange(id: any){
        return this.http.post('api/markPasswordChange', id);
    }
}
